import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_APPOINTMENT_NOTE' as const;
export { ExportStatus as Status };
